import Mankind from "./LandingPage/MankindPharma"
import BrandDays from "./LandingPage/BrandDays"
import SunPharma from "./LandingPage/SunPharma"
import { Carousel } from "./LandingPage/Carousel"
import CategoriesOnFocus from "./LandingPage/CategoriesOnFocus"
import { LimitedTimeDeals } from "./LandingPage/LimitedTimeDeals"
import FeaturingCompanies from "./LandingPage/FeaturingCompanies"
import ShopByCategory from "./LandingPage/ShopByCategory"
import TopBrands from "./LandingPage/TopBrands"
import TrendingToday from "./LandingPage/TrendingToday"
import { FreeHomeDelivery } from "./LandingPage/FreeHomeDelivery"
import { Box } from "@chakra-ui/react"
import UsvPharma from "./LandingPage/UsvPharma"
import IpcaPharma from "./LandingPage/IpcaPharma"
import AristoPharma from "./LandingPage/AristoPharma"
import FDCPharma from "./LandingPage/FDCPharma"
import WhatsAppChatButton from "./LandingPage/whatsappbutton"
import SEO from "./SEO/Seo"

export const Landing = () => {
    return <Box bg='#f3f7fb'>
        <SEO
        title="Udyog - Empowering India's Pharmacies"
        description="Transforming unorganized pharmacies into modern healthcare centers, connecting communities with essential services."
        keywords="Udyog, pharmacy empowerment, healthcare ecosystem, unorganized pharmacies, India, branding, resources, community health, first aid, basic consultations, accessible healthcare"
        />
    <Carousel/>
    <FreeHomeDelivery/>
    <TrendingToday/>
    <LimitedTimeDeals/>
    <SunPharma/>
    <ShopByCategory/>
    <UsvPharma/>
  
    <BrandDays/>
    <FeaturingCompanies/>
    <IpcaPharma/>
    <AristoPharma/>
    <TopBrands/>
    <CategoriesOnFocus/>
    <FDCPharma/>
    {/* <ExploreBeauty/> */}
    <Mankind/>
    <WhatsAppChatButton/>
    {/* <HealthLibrary/> */}
    {/* <AboutSome/> */}
    </Box>
}